import React from "react"
import { GetStaticProps } from "next"
import { PHASE_PRODUCTION_BUILD } from "next/constants"
import { IntlProvider } from "next-intl"
import * as Sentry from "@sentry/nextjs"
import FinderClient, { ActiveHealthInsuranceItem } from "../src/pages/FinderClient"
import { loadPartnerInsurances } from "../src/server/partnerInsurances"

export const getStaticProps: GetStaticProps = async (context) => {
  const locale = (context.locale as string) || "de"

  let messages
  try {
    messages = (await import(`../src/intl/${locale}.json`)).default
  } catch (err) {
    messages = (await import(`../src/intl/de.json`)).default
  }

  // During `next build` and in dev there is no previous page to fall back on, so
  // render with an empty list and retry soon. At runtime (ISR revalidation) a
  // failed or empty fetch throws instead, which makes Next.js keep the last good
  // page rather than caching an empty dropdown for 15 minutes.
  const tolerateFailure =
    process.env.NEXT_PHASE === PHASE_PRODUCTION_BUILD || process.env.NODE_ENV !== "production"

  const { partnerInsurances, revalidate } = await loadPartnerInsurances({
    tolerateFailure,
    onError: (error) => {
      console.error("Could not load partner insurance data", error)
      Sentry.captureException(error)
    },
  })

  return {
    props: {
      messages,
      locale,
      partnerInsurances,
    },
    revalidate,
  }
}

export default function FinderPage({
  messages,
  locale,
  partnerInsurances,
}: {
  messages: Record<string, any>
  locale: string
  partnerInsurances: ActiveHealthInsuranceItem[]
}) {
  return (
    <IntlProvider locale={locale} messages={messages}>
      <FinderClient partnerInsurances={partnerInsurances} />
    </IntlProvider>
  )
}
